import type { ReactNode } from "react";
import { waveTextContainsHttpLink, WAVE_HTTP_URL_REGEX } from "@vida/wave-core";

export { WAVE_HTTP_URL_REGEX };

export function waveTextContainsLink(text: string): boolean {
  return waveTextContainsHttpLink(text);
}

export function renderLinkifiedText(text: string): ReactNode[] {
  const parts: ReactNode[] = [];
  WAVE_HTTP_URL_REGEX.lastIndex = 0;
  let last = 0;
  let match: RegExpExecArray | null;
  let key = 0;

  while ((match = WAVE_HTTP_URL_REGEX.exec(text)) !== null) {
    if (match.index > last) {
      parts.push(text.slice(last, match.index));
    }
    const href = match[0];
    parts.push(
      <a
        key={key++}
        className="wave-inline-link"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        {href}
      </a>,
    );
    last = WAVE_HTTP_URL_REGEX.lastIndex;
  }

  if (last < text.length) {
    parts.push(text.slice(last));
  }

  return parts.length ? parts : [text];
}
